import { useTranslation } from 'next-i18next';
import { useLocaleContext } from '../../../../context/localeContext';
import { useAlgoliaFilter } from '../../../../hooks/useAlgoliaFilter';
import { useExitAnimation } from '../../../../hooks/useExitAnimation';
import { useMediaMatch } from '../../../../hooks/useMediaMatch';
import { useMobileOverlay } from '../../../../hooks/useMobileOverlay';
import { Close, Refine } from '../../../../icons';
import { media } from '../../../../stylings';
import { getCtLocale } from '../../../../utils/internationalization';
import OverLay from '../../overLay/OverLay';
import { DisplayFacets } from '../DisplayFacets';
import type { FilterMenuProps } from '../FilterMenu/FilterMenu';
import { CloseButton, Divider, FilterButton, FilterContainer, Header } from './MobileFilterMenu.styles';

export function MobileFilterMenu({ facetSequence = [], productCount }: FilterMenuProps) {
  const { locale } = useLocaleContext();
  const upperCaseLocale = getCtLocale(locale);

  const algoliaFilter = useAlgoliaFilter(upperCaseLocale);

  const { t } = useTranslation(['lib-global-common']);

  const isDesktop = useMediaMatch(media.greaterThan('lg'));

  const { handleOpenOverlay, isOverLayOpen } = useMobileOverlay();
  const { handleExitAnimation, isClosing } = useExitAnimation({ callbackFunction: handleOpenOverlay });

  if (isDesktop || algoliaFilter.isFiltersEmpty) return null;

  return (
    <>
      <FilterContainer>
        <FilterButton onClick={handleOpenOverlay} data-testid="filterButton">
          {t('filter.menu.filter')}
          <Refine />
        </FilterButton>
      </FilterContainer>

      <OverLay
        isClosing={isClosing}
        handleOpenOverlay={handleExitAnimation}
        isOverLayOpen={isOverLayOpen}
        testId="filterMenu"
      >
        <>
          <Header data-testid="filterHeader">
            <h4>{t('filter.menu.filter.by')}</h4>
            <CloseButton aria-label="close filter" onClick={handleExitAnimation} data-testid="filterCloseButton">
              <Close viewBox="0 -1 20 20" />
            </CloseButton>
          </Header>
          <Divider />

          <DisplayFacets productCount={productCount} facetSequence={facetSequence} algoliaFilter={algoliaFilter} />
        </>
      </OverLay>
    </>
  );
}
